import { InitialPayload, readArray } from '../shared/payloadReaders';

export const MAX_CHARS = 255;
export const MAX_VERSO_BLOCKS = 3;

export type VersoBlockType = 'text' | 'website' | 'phone_number';

export const VERSO_BLOCK_TYPES: Array<{ value: VersoBlockType; label: string; placeholder: string }> = [
  { value: 'text', label: 'Texte', placeholder: 'Contenu du bloc...' },
  { value: 'website', label: 'Site web', placeholder: 'https://...' },
  { value: 'phone_number', label: 'Téléphone', placeholder: 'Numéro de téléphone...' },
];

export interface VersoBlock {
  id: string;
  type: VersoBlockType;
  label: string;
  content: string;
}

export const readVersoBlocks = (payload: InitialPayload): VersoBlock[] =>
  readArray<Partial<VersoBlock>>(payload, 'versoBlocks').map((block, index) => ({
    id: block.id ?? `block-${index}`,
    type: block.type ?? 'text',
    label: block.label ?? '',
    content: block.content ?? '',
  }));

export const newVersoBlock = (): VersoBlock => ({ id: `block-${Date.now()}`, type: 'text', label: '', content: '' });
